import {Component, Input, OnInit} from '@angular/core';
import {DeviceFullDTO} from '../../../services/api/api';
import {TranslateService} from '@ngx-translate/core';
import {DeviceService} from '../../../services/device/deviceService';

@Component({
  selector: 'sb-comp-device-online-status-card',
  templateUrl: './sb-device-online-status-card.component.html',
  styleUrls: ['./sb-device-online-status-card.component.scss'],
  standalone: false,
})
export class SbDeviceOnlineStatusCardComponent implements OnInit {
  @Input() device: DeviceFullDTO;
  @Input() tooltipPlacement: string;

  tooltip: string;
  text: string;
  color: string;

  constructor(
    public translate: TranslateService,
    public deviceService: DeviceService
  ) {}

  ngOnInit(): void {
    this.initFields();
    this.translate.onDefaultLangChange.subscribe(() => {
      this.initFields();
    });
  }

  private initFields() {
    this.tooltip = this.deviceService.lastOnlineTitle(this.device);
    this.text = this.deviceService.lastOnline(this.device);
    this.color = this.deviceService.iconColor(this.device);
  }
}
